import * as React from "react";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import axios from "axios";
import { GraphFileBrowser } from "@microsoft/file-browser";
import { ActionButton } from "office-ui-fabric-react/lib/Button";
import {
  getTokenSilent,
  MSAL_CONFIG,
  getTokenSilentmsal,
} from "../../../msalConfig";
// import { MSAL_INSTANCE, MSAL_INSTANCEOD, myMSALObj } from "../../../index";
import * as moment from "moment";
import { IOneDriveFileData } from "./IOneDrivePickerData";
import {
  Providers,
  TeamsHelper,
  TeamsProvider,
  MsalProvider,
} from "@microsoft/mgt";
import "./GraphFileBrowser.scss";
import { EXAM_MODE } from '../../actions/constants';
import { loadExternalScript } from '../../utils/loadExternalScript';



export interface SkolonPickerProps {
  onClose: (selecteditems: any) => void;
}

export interface ISkolonPickerrState {
picker:any;
loading:boolean;
loadError:boolean;
}

const SKOLON_PICKER_URL = 'https://api.skolon.com/v1/plugins/appPicker.js?client_id=symRnEvnTx7UxSmtRx7eopLiQ9kAmCnj';

export default class SkolonPicker extends React.Component<
SkolonPickerProps,
  ISkolonPickerrState
> {
  constructor(props) {
    super(props); 
    this.state = { picker:null, loading:false, loadError:false };
  }
  onModalOpen = async () => {
   if (EXAM_MODE) {
     return;
   }
   this.setState({ loading: true, loadError: false });
   try {
     await this.ensurePicker();
     this.state.picker.open();
   }
   catch (error) {
     this.setState({ loadError: true });
   }
   finally {
     this.setState({ loading: false });
   }
  };

   onModalCancel = () => {
    this.state.picker.close();
   };
  ensurePicker = async () => {
     if (this.state.picker) {
       return;
     }
     await loadExternalScript(SKOLON_PICKER_URL, 'zokrates-skolon-picker');
     const skolon = (window as any).skolon;
     if (!skolon || !skolon.plugin || !skolon.plugin.AppPicker) {
       throw new Error('Skolon picker was not available after loading its script');
     }
     let tmp = new skolon.plugin.AppPicker({
        pickedAppCallback: (app)=>{
            this.props.onClose(app);
            tmp.close()
        },
        cancelCallback: ()=>{
            tmp.close()
        },
        hideCloseButton: false
        });
     await new Promise<void>((resolve) => this.setState({picker:tmp}, resolve));
  }

  public render() {
    if (EXAM_MODE) {
      return null;
    }
    // console.log('expiry2',this.getAuthenticationToken());
    
    return (
      <>
    
        {/* <ActionButton
          iconProps={{ iconName: "Education" }}
        
          onClick={this.onModalOpen}
        >
          Legg til læringsressurs
        </ActionButton> */}

        <ActionButton
          iconProps={{ iconName: "Add" }}
          disabled={this.state.loading}
          onClick={this.onModalOpen}
        >
          {this.state.loading ? 'Laster Skolon...' : 'Legg til læringsressurs fra Skolon'}
        </ActionButton>
        {this.state.loadError && <span>Skolon er ikke tilgjengelig.</span>}

      </>
    );
  }
}
